import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MountainsLookoutTowerBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MOUNTAINS_LOOKOUT_TOWER;
}

export default MountainsLookoutTowerBuildingTileEntity;
